import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Carousel from "./components/Carousel";
import Footer from "./components/Footer";
import TourCategories from "./components/TourCategories";
import PopularDestination from "./components/PopularDestination";
import OurOffer from "./components/OurOffer";
import SightSeeing from "./components/SightSeeing";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
// import FloatingImage from "./assests/AIicon.png";
import FloatingAIButton from "./components/FloatingAIButton";
import Modal from "./Modal";
import Walkthrough from "./components/Walkthrough";
import styled from "styled-components";
import { useFeedback } from "./context/FeedbackContext";

// Create a styled container to add space for the navbar
const MainContent = styled.div`
  padding-top: 60px; /* Same as navbar height */
`;

const Home = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalStep, setModalStep] = useState(1); // Track modal step for tour sync
  const location = useLocation();
  const { showFeedback } = useFeedback();

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalStep(1); // Reset modal step when closing
  };

  // Check for feedback link from email
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const showFeedbackParam = params.get("feedback");
    const bookingId = params.get("bookingId");

    if (showFeedbackParam === "true") {
      // Show feedback popup with email_link trigger type
      setTimeout(() => {
        showFeedback("email_link", { bookingId });
      }, 1000);
    }
  }, [location.search, showFeedback]);

  // Automatically open the modal after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      openModal();
    }, 5000);

    // Clean up the timer if the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <MainContent>
        <Carousel onOpenModal={openModal} />
        <TourCategories />
        <PopularDestination />
        <OurOffer />
        <SightSeeing />
        <Gallery />
        <Testimonials />
        <Footer />
      </MainContent>
      {/* Floating box with image */}
      <div style={styles.floatingBox}>
        <FloatingAIButton onClick={openModal} />
      </div>
      {/* Modal */}
      {isModalOpen && <Modal closeModal={closeModal} onStepChange={setModalStep} />}
      <Walkthrough isModalOpen={isModalOpen} modalStep={modalStep} />
    </>
  );
};

const styles = {
  floatingBox: {
    position: "fixed",
    bottom: "20px",
    right: "115px",
    width: "96px",
    height: "96px",
    display: "flex",
    borderRadius: "15px",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1001, // Higher than navbar to ensure visibility
  },
  floatingButton: {
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "15px",
  },
  floatingImage: {
    width: "96px",
    height: "96px",
    objectFit: "cover",
    borderRadius: "15px",
  },
};

export default Home;